import React, { useMemo, useState } from 'react';
import { Card, Button, Typography, Tag, Space, Divider, Row, Col, Table, Checkbox, Radio, Tabs, Modal, Form, Input, Select, Upload, message, Drawer, Badge, List, Descriptions, InputNumber, Switch } from 'antd';
import { 
    ArrowLeftOutlined, 
    EditOutlined, 
    InfoCircleOutlined, 
    AppstoreOutlined,
    DeploymentUnitOutlined,
    SettingOutlined,
    InboxOutlined,
    QuestionCircleOutlined,
    DownOutlined,
    CameraOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';

const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const ProductInformation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [editVisible, setEditVisible] = useState(false);
    const [editForm] = Form.useForm();

    // 弹窗相关状态
    const [detailVisible, setDetailVisible] = useState(false);
    const [detailContent, setDetailContent] = useState({ title: '', content: '', type: 'text' });
    const [modelDrawerVisible, setModelDrawerVisible] = useState(false);
    const [activeTab, setActiveTab] = useState('1');
    const [regionMode, setRegionMode] = useState('whitelist');
    const [selectedCountries, setSelectedCountries] = useState(['CN', 'JP', 'KR']);
    const [regionModalVisible, setRegionModalVisible] = useState(false);
    const [regionForm] = Form.useForm();
    const [activeMenu, setActiveMenu] = useState('联网方式');

    // 模拟物模型数据
    // 模拟物模型数据
    const thingModelData = {
        '设备能力': {
            '配置选项': [
                '联网方式', '对讲设置', '存储设置', '电池设置', '工作模式', '唤醒能力', 'OTA能力', '指示灯', '红外灯', '报警录制'
            ],
            // 设备能力下的所有子项共用这两组数据
            sharedStandard: [
                { type: '属性', name: '1234', identifier: '1234', dataType: 'Int(数字)', dataDef: '取值范围: 1 - 1', desc: '-', module: '-' },
                { type: '属性', name: '123', identifier: '123422', dataType: 'Int(数字)', dataDef: '取值范围: 123 - 2222', desc: '-', module: '官方测试3' }
            ],
            sharedCustom: [
                { type: '属性', name: '客流人数统计开关', identifier: 'CalcSwitch', dataType: 'Boolean(布尔)', dataDef: '开启-1 关闭-0', desc: '-', module: '-' }
            ],
            '联网方式': {
                config: [
                    { label: '联网方式', type: 'checkbox', options: ['有线', 'WIFI', '移动网络'], value: ['WIFI'] },
                    { label: '是否支持双频路由器', type: 'radio', options: ['否', '是'], value: '是' },
                    { label: '配网方式', type: 'checkbox', options: ['AP', '声音', 'smartlink', '摄像机识别二维码添加', '局域网', 'APP扫码添加', '蓝牙添加'], value: ['声音', 'smartlink'] }
                ]
            },
            '对讲设置': {
                config: [
                    { label: '对讲模式', type: 'radio', options: ['全双工', '半双工'], value: '全双工' },
                ]
            },
            '存储设置': { config: [] },
            '电池设置': { config: [] },
            '工作模式': { config: [] },
            '唤醒能力': { config: [] },
            'OTA能力': { config: [] },
            '指示灯': { config: [] },
            '红外灯': { config: [] },
            '报警录制': { config: [] }
        },
        '镜头配置': {
            '配置选项': ['多目配置', 'PTZ控制', '视频码流', '图像参数', '隐私区域', '水印', '鱼眼矫正', '高级选项'],
            'globalConfig': { label: '摄像机工作模式', options: ['独立工作', '联动工作'], value: '独立工作' },
            'cardTitle': '单目配置',
            'instanceName': 'Camera_1',
            'instanceLabel': '切换镜头',
            'sharedStandard': [
                { key: 'lens-1', type: '标准能力', name: '镜头状态', identifier: 'lens_status', dataType: '枚举', dataDef: '0:关闭, 1:开启', desc: '镜头开关状态', module: '镜头' }
            ],
            'sharedCustom': [],
            '多目配置': {
                multiTarget: [
                    { id: 1, label: '镜头 1', type: '普通镜头', maxFocal: 0, minFocal: 0 },
                    { id: 2, label: '镜头 2', type: '普通镜头', maxFocal: 0, minFocal: 0 }
                ]
            },
            'PTZ控制': { 
                config: [
                    { label: '是否支持PTZ', type: 'radio', options: ['支持', '不支持'], value: '不支持' },
                    { label: 'PTZ能力', type: 'checkbox', options: ['平移', '倾斜', '变焦'], value: [] },
                    { label: '是否支持预置位', type: 'radio', options: ['支持', '不支持'], value: '不支持' },
                    { label: '是否支持自动巡航', type: 'radio', options: ['支持', '不支持'], value: '不支持' },
                    { label: '空间定位能力', type: 'radio', options: ['不支持', '支持3D居中', '支持3D定位'], value: '不支持' },
                ] 
            },
            '视频码流': { config: [] },
            '图像参数': { config: [] },
            '隐私区域': { config: [] },
            '水印': { config: [] },
            '鱼眼矫正': { config: [] },
            '高级选项': { config: [] }
        },
        '麦克风配置': {
            '配置选项': ['麦克风参数配置', '音频码流配置'],
            'sharedStandard': [
                { key: 'mic-1', type: '标准能力', name: '采集音量', identifier: 'mic_volume', dataType: '数值', dataDef: '0-100', desc: '设置采集音量', module: '麦克风' }
            ],
            'sharedCustom': [],
            '麦克风参数配置': {
                instanceName: 'Microphone_1',
                config: [
                    { label: '麦克风开关', type: 'switch', value: false },
                    { label: '音量调节', type: 'radio', options: ['支持', '不支持'], value: '不支持' },
                    { label: '采集音量', type: 'input-number', value: 0 },
                    { label: '采样位深', type: 'radio', options: ['16bit', '24bit'], value: '16bit' },
                    { label: '采样率', type: 'radio', options: ['8000 (电话音质)', '16000 (语音识别常用)', '44100 (CD音质)', '48000 (专业音频常用)'], value: '8000 (电话音质)' },
                    { label: '声道数', type: 'radio', options: ['单声道', '双声道'], value: '单声道' },
                ]
            },
            '音频码流配置': {
                config: [
                    { label: '码流 1', type: 'title' },
                    { label: '支持的编码类型', type: 'checkbox', options: ['PCM', 'G711A', 'G711U', 'AAC', 'MP3'], value: [] },
                    { label: '默认编码类型', type: 'select', options: ['请选择'], value: '请选择' },
                ]
            }
        },
        '屏显配置': {
            '配置选项': [],
            'globalConfig': { label: '是否有屏显', options: ['是', '否'], value: '是' },
            'instanceName': 'Screen_1',
            'standard': [
                { key: 'disp-1', type: '标准能力', name: '屏幕亮度', identifier: 'screen_brightness', dataType: '数值', dataDef: '0-100', desc: '显示屏亮度调节', module: '屏显' }
            ],
            'custom': [],
            'config': [
                { label: '支持的分辨率', type: 'checkbox', options: ['1920*1080', '1280*720', '640*480', '640*360', '320*240'], value: [] },
                { label: '屏息时间 (秒)', type: 'input-number', value: 0 },
                { label: '支持的解码方式', type: 'checkbox', options: ['H264', 'H265', 'MJPG'], value: [] },
                { label: '支持的屏显类型', type: 'checkbox', options: ['文字', '背景图', '图片', '视频'], value: [] },
            ]
        },
        '喇叭配置': {
            '配置选项': [],
            'globalConfig': { label: '是否有喇叭', options: ['是', '否'], value: '是' },
            'instanceName': 'Speaker_1',
            'standard': [
                { key: 'spk-1', type: '标准能力', name: '播放音量', identifier: 'speaker_volume', dataType: '数值', dataDef: '0-100', desc: '扬声器播放音量', module: '喇叭' }
            ],
            'custom': [],
            'config': [
                { label: '支持的编码方式', type: 'checkbox', options: ['PCM', 'G711A', 'g711u', 'ACC'], value: [] },
                { label: '音量调节', type: 'radio', options: ['支持', '不支持'], value: '不支持' },
                { label: '音量', type: 'input-number', value: 0 },
                { label: '自定义铃声', type: 'radio', options: ['支持', '不支持'], value: '不支持' },
                { label: '采样位深', type: 'radio', options: ['16bit', '24bit'], value: '16bit' },
                { label: '采样率', type: 'radio', options: ['8000 (电话音质)', '16000 (语音识别常用)', '44100 (CD音质)', '48000 (专业音频常用)'], value: '8000 (电话音质)' },
                { label: '声道数', type: 'radio', options: ['单声道', '双声道'], value: '单声道' },
            ]
        },
        '云端抓图': {
            '配置选项': [],
            'config': [
                { label: '是否支持', type: 'radio', options: ['是', '否'], value: '是' },
                { label: '默认开启', type: 'radio', options: ['开启', '关闭'], value: '开启' },
                { label: '支持动图', type: 'radio', options: ['是', '否'], value: '是' },
                { label: '动图开关', type: 'radio', options: ['开启', '关闭'], value: '关闭' },
                { label: '抓图质量', type: 'select', options: ['大图', '中图', '小图'], value: '大图' },
                { label: '存储时长(天)', type: 'input-number', value: 7, suffix: '天' },
                { label: '存储方式', type: 'radio', options: ['事件', '定时'], value: '事件' },
                { label: '存储格式', type: 'radio', options: ['已有格式，带有私有头', '标准jpg'], value: '已有格式，带有私有头' },
                { label: '抓拍间隔', type: 'select', options: ['30秒', '60秒', '512秒'], value: '30秒' },
            ],
            'alert': '云端抓图：该配置会影响设备的报警抓图能力，请谨慎选择',
            'hideTables': true
        }
    };

    const tabLabelMap = { '1': '设备能力', '2': '镜头配置', '3': '麦克风配置', '4': '屏显配置', '5': '喇叭配置', '6': '云端抓图' };

    const getActiveData = () => {
        const currentTabLabel = tabLabelMap[activeTab];
        const tabData = thingModelData[currentTabLabel];
        const defaultData = { config: [], standard: [], custom: [] };
        if (!tabData) return defaultData;

        // 如果配置选项为空，说明该 Tab 是扁平结构（如：云端抓图、喇叭配置、屏显配置）
        if (!tabData['配置选项'] || tabData['配置选项'].length === 0) {
            return {
                config: tabData.config || [],
                multiTarget: tabData.multiTarget || [],
                standard: tabData.standard || [],
                custom: tabData.custom || [],
                globalConfig: tabData.globalConfig,
                alert: tabData.alert,
                hideTables: tabData.hideTables
            };
        }

        const menuData = tabData[activeMenu] || defaultData;
        const sharedTabs = ['设备能力', '镜头配置', '麦克风配置', '屏显示配置', '喇叭配置'];

        // 如果是特定 Tab，共用该 Tab 顶层的能力数据
        if (sharedTabs.includes(currentTabLabel)) {
            return {
                ...tabData,
                ...menuData,
                multiTarget: menuData.multiTarget || [],
                standard: tabData.sharedStandard || tabData.standard || [],
                custom: tabData.sharedCustom || tabData.custom || []
            };
        }

        return menuData;
    };

    const activeData = getActiveData();

    const showDetail = (title, content, type = 'text') => {
        setDetailContent({ title, content, type });
        setDetailVisible(true);
    };

    const renderAppConfigDetails = () => (
        <Descriptions column={1} size="small" bordered labelStyle={{ width: 140, backgroundColor: '#fafafa' }}>
            <Descriptions.Item label="默认分辨率">标清 (SD)</Descriptions.Item>
            <Descriptions.Item label="插值设置">
                <Space direction="vertical" size={0}>
                    <Text>图片插值: 关闭</Text>
                    <Text>视频插值: 关闭</Text>
                </Space>
            </Descriptions.Item>
            <Descriptions.Item label="全彩模式时段">定时开启</Descriptions.Item>
            <Descriptions.Item label="App 安全策略">
                <Text>视频播放时长限制: 开启限制(120秒, 预警剩余30秒)</Text>
            </Descriptions.Item>
            <Descriptions.Item label="一键报警配置">不屏蔽</Descriptions.Item>
            <Descriptions.Item label="假三目设置">关闭</Descriptions.Item>
            <Descriptions.Item label="灯控开关显示">
                <Text>不显示</Text>
            </Descriptions.Item>
        </Descriptions>
    );

    // 状态配置映射
    const statusConfig = {
        '0': { text: '开发中', color: 'orange', bgColor: '#fff7e6' },
        '1': { text: '已发布', color: 'green', bgColor: '#f6ffed' },
        '2': { text: '隐藏', color: 'gray', bgColor: '#f5f5f5' },
        '发布中': { text: '发布中', color: 'blue', bgColor: '#e6f7ff' },
        '发布失败': { text: '发布失败', color: 'red', bgColor: '#fff1f0' },
        '可发布': { text: '可发布', color: 'cyan', bgColor: '#e6fffb' }
    };

    // 操作按钮配置
    const getActionButtons = () => {
        const status = productData.status;
        const buttons = [];

        // 基础按钮：编辑基本信息
        // 发布中、已发布 状态展示
        if (status === '发布中' || status === '1') {
            buttons.push(
                <Button key="edit" icon={<EditOutlined />} onClick={handleEditClick}>
                    编辑基本信息
                </Button>
            );
        }

        // 继续开发 按钮：开发中、可发布、发布失败 状态展示
        if (status === '0' || status === '可发布' || status === '发布失败') {
            buttons.push(
                <Button 
                    key="continue" 
                    type="primary" 
                    onClick={() => navigate('/product/develop', { state: productData })}
                >
                    继续开发
                </Button>
            );
        }

        // 发布产品 按钮：可发布 状态展示
        if (status === '可发布') {
            buttons.push(
                <Button 
                    key="publish" 
                    type="primary" 
                    onClick={() => {
                        Modal.confirm({
                            title: '无法发布',
                            content: '产品的初版生产固件尚未定版，暂不支持发布产品。',
                            okText: '立即前往',
                            cancelText: '我知道了',
                            onOk: () => navigate(`/firmware/version?productId=${productData.id}&productName=${encodeURIComponent(productData.name)}`),
                        });
                    }}
                >
                    发布产品
                </Button>
            );
        }

        return buttons;
    };

    // 从路由或 location.state 中获取动态数据
    const productData = useMemo(() => {
        const state = location.state || {};
        return {
            name: state.name || '前端测试复制产品',
            status: state.status !== undefined ? String(state.status) : '1', 
            id: state.id || 'PV3Pu4mmAxhfe8rh',
            category: state.category || '摄像机',
            subCategory: state.subCategory || '4G常电',
            model: state.model || 'HM-MODEL-001',
            desc: state.desc || '这是一个智能摄像机产品，支持人形检测和语音交互。',
            createTime: state.createTime || '2026-03-04 16:53:40',
            updateTime: state.updateTime || '2026-03-05 10:48:39',
            price: state.price || '10.00',
            stats: state.stats || {
                stdAbility: 0,
                cueAbility: 0,
                algorithms: 0,
                vas: 0
            },
            source: state.source || undefined,
            vendorName: state.vendorName || undefined,
            vendorProductName: state.vendorProductName || undefined
        };
    }, [location.state]);

    const isPublishedOrReleasing = productData.status === '1' || productData.status === '发布中';

    const handleEditClick = () => {
        editForm.setFieldsValue({
            category: productData.category,
            subCategory: productData.subCategory,
            name: productData.name,
            model: productData.model,
            desc: productData.desc
        });
        setEditVisible(true);
    };

    const handleEditSubmit = () => {
        editForm.validateFields().then(values => {
            message.success('产品基本信息修改成功');
            setEditVisible(false);
        });
    };

    const firmwareColumns = [
        { title: '固件名称', dataIndex: 'name', key: 'name', render: (text) => <Text strong>{text || '-'}</Text> },
        { title: '固件版本', dataIndex: 'version', key: 'version', render: (v) => <Tag color="blue">{v || 'v1.0.0'}</Tag> },
        { title: '固件说明', dataIndex: 'desc', key: 'desc', width: 300, ellipsis: true },
        { title: '创建时间', dataIndex: 'updateTime', key: 'updateTime', width: 180 },
    ];
    // 增加有内容的模拟数据
    const firmwareData = [
        {
            key: '1',
            name: 'P2P网络摄像头固件',
            version: 'v2.3.5_20240305',
            versionCount: 12,
            desc: '优化了低光环境下的图像噪点，修复了部分WiFi环境下断连的问题，增强了ONVIF协议兼容性。',
            updateTime: '2026-03-05 10:48:39'
        },
        {
            key: '2',
            name: 'AI人形检测驱动',
            version: 'v1.0.8',
            versionCount: 4,
            desc: '提升了侧脸识别准确率，降低了宠物误报率。',
            updateTime: '2026-03-04 16:53:40'
        }
    ];

    // 模拟 交互控制 (基于截图内容)
    const interactionConfigData = [ // eslint-disable-line no-unused-vars
        {
            group: 'APP路径配置',
            items: [
                { label: '功能名称', value: '1234', module: '设备能力', desc: '-', path: '/pages/device/control' },
                { label: '功能名称', value: '客流统计', module: '设备能力', desc: '-', path: '/pages/device/stat' }
            ]
        },
        {
            group: '语音控制',
            items: [
                { label: 'Alexa(语音助手)', value: '已接入', type: 'checked' },
                { label: 'Google Home', value: '已接入', type: 'checked' },
                { label: '天猫精灵', value: '未接入', type: 'radio' }
            ]
        },
        {
            group: '推送配置',
            items: [
                { label: '报警消息', value: '设备侦测到移动目标', status: '已开启', type: 'switch' },
                { label: '系统消息', value: '设备上线/下线通知', status: '已开启', type: 'switch' }
            ]
        }
    ];

    return (
        <div style={{ backgroundColor: '#f4f7f9', minHeight: '100vh', padding: '24px' }}>
            {/* 顶层导航及核心操作 */}
            <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Space size={12}>
                    <Button 
                        icon={<ArrowLeftOutlined />} 
                        onClick={() => navigate(-1)}
                        style={{ border: 'none', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}
                    />
                    <div style={{ marginLeft: 8 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <Title level={4} style={{ margin: 0 }}>{productData.name}</Title>
                            <Tag 
                                color={statusConfig[productData.status]?.color || 'default'} 
                                bordered={false} 
                                style={{ borderRadius: 10, padding: '0 12px' }}
                            >
                                {statusConfig[productData.status]?.text || '未知状态'}
                            </Tag>
                            <Tag color="blue" bordered={false} style={{ borderRadius: 10, padding: '0 12px' }}>整机产品</Tag>
                            {productData.source === 'ecosystem' && <Text type="secondary" style={{ fontSize: 12 }}>方案商：{productData.vendorName || '-'} ｜ 方案产品：{productData.vendorProductName || '-'}（{productData.vendorProductId || '-'}）</Text>}
                        </div>
                        <Text type="secondary" style={{ fontSize: 12 }}>产品ID: {productData.id}</Text>
                    </div>
                </Space>
                <Space>
                    {getActionButtons()}
                </Space>
            </div>

            <Row gutter={20}>
                {/* 左侧：核心看板 */}
                <Col span={18}>
                    <Space direction="vertical" size={20} style={{ width: '100%' }}>
                        {/* 统计横排 */}
                        <Row gutter={16}>
                            {[
                                { 
                                    title: '物模型配置', 
                                    sub: (
                                        <span style={{ color: '#1890ff' }}>
                                            查看配置
                                        </span>
                                    ), 
                                    icon: <SettingOutlined />, 
                                    color: '#faad14',
                                    onClick: () => setModelDrawerVisible(true)
                                },
                                { 
                                    title: '设备算法', 
                                    sub: <span>已配置 <Text strong>4</Text> 项</span>,
                                    icon: <DeploymentUnitOutlined />, color: '#722ed1' 
                                },
                                { 
                                    title: '平台服务', 
                                    sub: <span>已配置 <Text strong>3</Text> 项</span>,
                                    icon: <DeploymentUnitOutlined />, color: '#eb2f96' 
                                },
                            ].map((item, index) => (
                                <Col span={8} key={index}>
                                    <div 
                                        onClick={item.onClick}
                                        style={{ cursor: item.onClick ? 'pointer' : 'default', height: '100%' }}
                                    >
                                        <Card bordered={false} bodyStyle={{ padding: 20 }} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', height: '100%', transition: 'all 0.3s' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                            <div style={{ width: 40, height: 40, borderRadius: 8, backgroundColor: item.color + '15', color: item.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>
                                                {item.icon}
                                            </div>
                                            <div>
                                                <div style={{ color: '#8c8c8c', fontSize: 12 }}>{item.title}</div>
                                                <div style={{ fontWeight: 600, marginTop: 2, display: 'flex', alignItems: 'center' }}>{item.sub}</div>
                                            </div>
                                        </div>
                                    </Card>
                                    </div>
                                </Col>
                            ))}
                        </Row>

                        {/* 设备算法 */}
                        <Card 
                            title={<span style={{ fontSize: 15, fontWeight: 600 }}>设备算法</span>} 
                            bordered={false} 
                            style={{ borderRadius: 12, marginBottom: 16 }}
                        >
                            <Table 
                                size="middle"
                                pagination={false}
                                dataSource={[
                                    { key: '1a', id: '1000', name: '人形检测', desc: '智能过滤非人物体，精确识别人物', serviceId: '300026', svcName: '人形检测服务', svcDesc: '基于AI的人形识别服务', config: [], events: [{ id: '100000', name: '人形侦测' }, { id: '100001', name: '人形识别' }], type: '基础算法', mode: '免开通(平台赠送)' },
                                    { key: '1b', id: '1000', name: '运动检测', desc: '监测画面中像素发生位移变化', serviceId: '300027', svcName: '运动检测服务', svcDesc: '监测画面像素变化', config: [], events: [], type: '基础算法', mode: '免开通(平台赠送)' },
                                    { key: '2', id: '1003', name: 'PIR红外检测', desc: '基于红外热释电的人体活动监测', serviceId: '300048', svcName: '红外检测', svcDesc: '基于红外热释电', config: [{ label: '红外切换模式', value: '自动' }, { label: '灵敏度', value: '中' }], events: [{ id: '100005', name: 'PIR人体侦测' }], type: 'AI高级算法', mode: '需在App购买使用' },
                                    { key: '3', id: '1096', name: '智能告警-儿童检测', desc: '综合全天候的儿童看护识别', serviceId: '300044', svcName: '儿童检测服务', svcDesc: '综合全天候儿童看护', config: [{ label: '间隔时间', value: '30s' }, { label: '算法灵敏度', value: '中' }], events: [{ id: '100300', name: '哭声侦测' }], type: '基础算法', mode: '免开通(平台赠送)' },
                                    { key: '4', id: '1112', name: '人脸检测', desc: '检测画面中出现的人脸', serviceId: '300018', svcName: '人脸检测服务', svcDesc: '检测画面中出现的人脸', config: [{ label: '人脸抓拍模式', value: '质量' }, { label: '置信度', value: '3' }], events: [], type: 'AI高级算法', mode: '需在App购买使用' },
                                ]}
                                columns={[
                                    { title: '算法ID', dataIndex: 'id', key: 'id', width: 80, render: (t) => <Text code>{t}</Text> },
                                    { title: '算法名称', dataIndex: 'name', key: 'name', render: (t) => <Text strong>{t}</Text> },
                                    { title: '服务ID', dataIndex: 'serviceId', key: 'serviceId', width: 100, render: (t) => <Text code style={{ fontSize: 12 }}>{t}</Text> },
                                    { title: '服务名称', dataIndex: 'svcName', key: 'svcName', width: 120, render: (t) => <Text strong>{t}</Text> },
                                    { title: '服务描述', dataIndex: 'svcDesc', key: 'svcDesc', width: 150, ellipsis: true, render: (t) => <Text type="secondary">{t}</Text> },
                                    { title: '算法配置', dataIndex: 'config', key: 'config', render: (c) => (c && c.length > 0) ? <Button type="link" size="small" onClick={() => showDetail('算法配置详情', c, 'list')}>查看</Button> : '-' },
                                    { title: '关联事件', dataIndex: 'events', key: 'events', render: (e) => (e && e.length > 0) ? <Button type="link" size="small" onClick={() => showDetail('关联事件', e, 'table')}>查看</Button> : '-' },
                                    { title: '开通方式', dataIndex: 'mode', key: 'mode', render: (m) => <Tag color={m === '免开通(平台赠送)' ? 'green' : 'orange'}>{m}</Tag> },
                                ]}
                            />
                        </Card>

                        {/* 平台服务 */}
                        <Card 
                            title={<span style={{ fontSize: 15, fontWeight: 600 }}>平台服务</span>} 
                            bordered={false} 
                            style={{ borderRadius: 12, marginBottom: 16 }}
                        >
                            <Table 
                                size="middle"
                                pagination={false}
                                dataSource={[
                                    { key: '1', id: '1010', name: '云存录像', serviceId: '300010', svcName: '事件云存', desc: '用于存储录制事件', supported: true, config: [{ label: '存储时长', value: '7天' }], mode: '免开通(平台赠送)' },
                                    { key: '2', id: '1010', serviceId: '300011', svcName: '全天云存', desc: '用于存储视频回看', supported: true, config: [{ label: '存储时长', value: '3天' }], mode: '需在App购买使用' },
                                    { key: '3', id: '1098', name: '智能告警服务', serviceId: '300009', svcName: '智能告警', desc: '基于多维参数的综合告警策略', supported: false, config: [], mode: '免开通(平台赠送)' },
                                    { key: '4', id: '1100', name: '时光相册', serviceId: '300007', svcName: '时光相册', desc: '生成精彩瞬间的时间轴视图', supported: false, config: [], mode: '免开通(平台赠送)' },
                                    { key: '5', id: '1063', name: '语音助手', serviceId: '300005', svcName: 'Alexa', desc: 'Amazon Alexa语音助手接入', supported: false, config: [], mode: '免开通(平台赠送)' },
                                    { key: '6', id: '1063', serviceId: '300006', svcName: 'Google Home', desc: 'Google Home语音助手接入', supported: false, config: [], mode: '免开通(平台赠送)' },
                                ]}
                                columns={[
                                    { title: 'ID(AIIoTType)', dataIndex: 'id', key: 'id', width: 100, render: (t) => <Text code>{t}</Text> },
                                    { title: '算法名称', dataIndex: 'name', key: 'name', width: 120, render: (t) => t ? <Text strong>{t}</Text> : null },
                                    { title: '服务ID', dataIndex: 'serviceId', key: 'serviceId', width: 100, render: (t) => <Text code style={{ fontSize: 12 }}>{t}</Text> },
                                    { title: '服务名称', dataIndex: 'svcName', key: 'svcName', width: 120, render: (t) => <Text strong>{t}</Text> },
                                    { title: '服务描述', dataIndex: 'desc', key: 'desc', ellipsis: true },
                                    { title: '开通方式', dataIndex: 'mode', key: 'mode', render: (m) => <Tag color={m === '免开通(平台赠送)' ? 'green' : 'orange'}>{m}</Tag> },
                                ]}
                            />
                        </Card>

                        {/* App 配置 */}
                        <Card 
                            title={<span style={{ fontSize: 15, fontWeight: 600 }}>App配置</span>} 
                            bordered={false} 
                            style={{ borderRadius: 12 }}
                            extra={
                                <Button 
                                    type="link" 
                                    onClick={() => navigate('/product/app')}
                                    icon={<SettingOutlined />}
                                >
                                    前往查看/修改
                                </Button>
                            }
                        >
                            <Row gutter={16}>
                                {[
                                    { 
                                        title: '安装指引', 
                                        icon: <InfoCircleOutlined style={{ color: '#1890ff' }} />, 
                                        data: [
                                            { label: '配置状态', value: '已配置', type: 'tag', color: 'green' }
                                        ]
                                    },
                                    { 
                                        title: '应用App', 
                                        icon: <AppstoreOutlined style={{ color: '#52c41a' }} />, 
                                        data: [
                                            { label: '使用权限', value: '不限制 / 限制使用4个App', type: 'text', strong: true }
                                        ]
                                    },
                                    { 
                                        title: '默认生效配置', 
                                        icon: <SettingOutlined style={{ color: '#faad14' }} />, 
                                        data: [
                                            { label: '配置详情', value: '查看详情', type: 'app-config-details' }
                                        ]
                                    }
                                ].map((section, idx) => (
                                    <Col span={8} key={idx}>
                                        <div style={{ padding: '4px 8px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                                                {section.icon}
                                                <Text strong>{section.title}</Text>
                                            </div>
                                            <List
                                                size="small"
                                                dataSource={section.data}
                                                renderItem={item => (
                                                    <List.Item style={{ padding: '4px 0', border: 'none' }}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontSize: 13 }}>
                                                            <Text type="secondary">{item.label}:</Text>
                                                            {item.type === 'app-config-details' ? (
                                                                <Button type="link" size="small" style={{ padding: 0, height: 'auto' }} onClick={() => showDetail(`默认生效配置详情`, 'app-config-details', 'custom')}>
                                                                    {item.value}
                                                                </Button>
                                                            ) : item.type === 'link' ? (
                                                                <Button type="link" size="small" style={{ padding: 0, height: 'auto' }} onClick={() => showDetail(`${section.title}-${item.label}`, [], 'list')}>
                                                                    {item.value}
                                                                </Button>
                                                            ) : item.type === 'tag' ? (
                                                                <Tag color={item.color} style={{ marginRight: 0, fontSize: 11 }}>{item.value}</Tag>
                                                            ) : (
                                                                <Text strong={item.strong}>{item.value}</Text>
                                                            )}
                                                        </div>
                                                    </List.Item>
                                                )}
                                            />
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Card>

                        {/* 固件模块：展示有内容的样式 */}
                        <Card 
                            title={<span style={{ fontSize: 15, fontWeight: 600 }}>固件版本管理（有固件内容演示）</span>} 
                            bordered={false} 
                            style={{ borderRadius: 12 }}
                            extra={<Button type="primary" size="small" ghost onClick={() => navigate(`/firmware/version?productId=${productData.id}&productName=${encodeURIComponent(productData.name)}`)}>新增固件</Button>}
                        >
                            <Table 
                                columns={firmwareColumns} 
                                dataSource={firmwareData} 
                                pagination={false}
                                size="middle"
                            />
                        </Card>

                        {/* 固件模块：保持表格但优化空态 */}
                        <Card 
                            title={<span style={{ fontSize: 15, fontWeight: 600 }}>固件版本管理（空态演示）</span>} 
                            bordered={false} 
                            style={{ borderRadius: 12 }}
                            extra={<Button type="primary" size="small" ghost onClick={() => navigate(`/firmware/version?productId=${productData.id}&productName=${encodeURIComponent(productData.name)}`)}>新增固件</Button>}
                        >
                            <Table 
                                columns={firmwareColumns} 
                                dataSource={[]} 
                                pagination={false}
                                size="middle"
                                locale={{ 
                                    emptyText: (
                                        <div style={{ padding: '20px 0' }}>
                                            <Text type="secondary">暂无固件版本信息</Text>
                                            {/* <div style={{ marginTop: 8 }}><Button size="small">关联已有固件</Button></div> */}
                                        </div>
                                    ) 
                                }}
                            />
                        </Card>
                    </Space>
                </Col>

                {/* 右侧：产品档案袋 */}
                <Col span={6}>
                    <Card bordered={false} style={{ borderRadius: 12, height: '100%' }}>
                        <div style={{ textAlign: 'center', padding: '10px 0 20px' }}>
                            <div style={{ width: 120, height: 120, margin: '0 auto', backgroundColor: '#fafafa', borderRadius: 12, border: '1px dashed #d9d9d9', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
                                <Text type="secondary" style={{ fontSize: 11 }}>产品图加载失败</Text>
                            </div>
                        </div>
                        <Divider style={{ margin: '12px 0' }} />
                        <div style={{ padding: '4px 0' }}>
                            <div style={{ marginBottom: 16 }}>
                                <div style={{ color: '#8c8c8c', fontSize: 12, marginBottom: 4 }}>产品类型 / 类目</div>
                                <div>{productData.category || '摄像机 / 智能视觉'}</div>
                            </div>
                            <div style={{ marginBottom: 16 }}>
                                <div style={{ color: '#8c8c8c', fontSize: 12, marginBottom: 4 }}>授权单价</div>
                                <Text strong style={{ color: '#f5222d', fontSize: 16 }}>¥ {productData.price || '0.00'}</Text>
                            </div>
                            <div style={{ marginBottom: 16 }}>
                                <div style={{ color: '#8c8c8c', fontSize: 12, marginBottom: 4 }}>免费授权数量</div>
                                <Text strong style={{ fontSize: 15 }}>{productData.freeQuota || 0}</Text>
                            </div>
                            <div style={{ marginBottom: 16 }}>
                                <div style={{ color: '#8c8c8c', fontSize: 12, marginBottom: 4 }}>生产授权数量</div>
                                <Text strong style={{ fontSize: 15 }}>{productData.producedNum || 0}</Text>
                            </div>
                            <div style={{ marginBottom: 16 }}>
                                <div style={{ color: '#8c8c8c', fontSize: 12, marginBottom: 4 }}>设备使用区域 <Button type="link" size="small" style={{ fontSize: 12, padding: 0 }} onClick={() => { regionForm.setFieldsValue({ regionMode, selectedCountries }); setRegionModalVisible(true); }}>设置</Button></div>
                                {regionMode === 'none' ? (
                                    <Tag>不限制</Tag>
                                ) : (
                                    <div>
                                        <Tag color={regionMode === 'whitelist' ? 'green' : 'red'}>{regionMode === 'whitelist' ? '白名单' : '黑名单'}</Tag>
                                        <div style={{ marginTop: 4, fontSize: 12, color: '#595959' }}>
                                            {selectedCountries.map(c => {
                                                const map = { CN: '中国', US: '美国', JP: '日本', KR: '韩国', DE: '德国', GB: '英国', FR: '法国', AU: '澳大利亚', IN: '印度', BR: '巴西', CA: '加拿大', RU: '俄罗斯', SG: '新加坡', TH: '泰国', VN: '越南' };
                                                return <Tag key={c} style={{ marginBottom: 2 }}>{map[c] || c}</Tag>;
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div style={{ marginBottom: 16 }}>
                                <div style={{ color: '#8c8c8c', fontSize: 12, marginBottom: 4 }}>时间节点</div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                                    <div style={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#52c41a' }} />
                                    创建于：{productData.createTime}
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, marginTop: 4 }}>
                                    <div style={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#1890ff' }} />
                                    更新于：{productData.updateTime}
                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>
            </Row>

            {/* 配置详情弹窗 */}
            <Modal
                title={detailContent.title}
                open={detailVisible}
                onOk={() => setDetailVisible(false)}
                onCancel={() => setDetailVisible(false)}
                footer={[
                    <Button key="close" type="primary" onClick={() => setDetailVisible(false)}>
                        关闭
                    </Button>
                ]}
                width={detailContent.type === 'table' ? 800 : 500}
            >
                <div style={{ padding: '10px 0' }}>
                    {detailContent.type === 'custom' && detailContent.content === 'app-config-details' && renderAppConfigDetails()}
                    {detailContent.type === 'group-list' && (
                        <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                            {Array.isArray(detailContent.content) && detailContent.content.map((group, gIdx) => (
                                <Card size="small" title={group.group} key={gIdx} style={{ marginBottom: 16, borderRadius: 8 }} headStyle={{ backgroundColor: '#fafafa', fontSize: 13 }}>
                                    {group.items.map((item, iIdx) => (
                                        <div key={iIdx} style={{ display: 'flex', marginBottom: 12, alignItems: 'baseline', borderBottom: iIdx === group.items.length - 1 ? 'none' : '1px dashed #f0f0f0', paddingBottom: iIdx === group.items.length - 1 ? 0 : 12 }}>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                                                    <Text strong style={{ minWidth: 120 }}>{item.label}</Text>
                                                    {item.status ? (
                                                        <Badge status={item.status === '已开启' ? 'success' : 'default'} text={item.status} />
                                                    ) : (
                                                        <Tag color="cyan" bordered={false}>{item.value}</Tag>
                                                    )}
                                                </div>
                                                {item.path && <div style={{ fontSize: 12, color: '#1890ff' }}>路径：{item.path}</div>}
                                                {item.desc && item.desc !== '-' && <div style={{ fontSize: 12, color: '#8c8c8c' }}>描述：{item.desc}</div>}
                                                {group.group === '推送配置' && <div style={{ fontSize: 12, color: '#8c8c8c' }}>内容：{item.value}</div>}
                                            </div>
                                        </div>
                                    ))}
                                </Card>
                            ))}
                        </div>
                    )}
                    {detailContent.type === 'list' && (
                        <div style={{ backgroundColor: '#fafafa', padding: '16px', borderRadius: '8px', border: '1px solid #f0f0f0' }}>
                            {Array.isArray(detailContent.content) && detailContent.content.map((item, index) => (
                                <div key={index} style={{ marginBottom: index === detailContent.content.length - 1 ? 0 : 16, borderBottom: index === detailContent.content.length - 1 ? 'none' : '1px dashed #f0f0f0', paddingBottom: index === detailContent.content.length - 1 ? 0 : 16 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                                        <Text strong style={{ minWidth: 120 }}>{item.label}</Text>
                                        <Tag color="processing" style={{ borderRadius: 4 }}>{item.value}</Tag>
                                    </div>
                                    {item.desc && <div style={{ fontSize: 12, color: '#8c8c8c', paddingLeft: 0 }}>描述：{item.desc}</div>}
                                </div>
                            ))}
                        </div>
                    )}
                    {detailContent.type === 'table' && (
                        <Table
                            size="small"
                            pagination={false}
                            dataSource={detailContent.content}
                            columns={[
                                { title: '事件ID', dataIndex: 'id', key: 'id' },
                                { title: '事件名称', dataIndex: 'name', key: 'name', render: (text) => <Text strong>{text}</Text> },
                                { title: '事件描述', dataIndex: 'desc', key: 'desc' },
                            ]}
                        />
                    )}
                    {detailContent.type === 'text' && (
                        <Text code style={{ display: 'block', whiteSpace: 'pre-wrap', padding: 12, backgroundColor: '#f5f5f5' }}>
                            {detailContent.content}
                        </Text>
                    )}
                </div>
            </Modal>

            {/* 编辑基本信息 Drawer */}
            <Drawer
                title="编辑基本信息"
                onClose={() => setEditVisible(false)}
                open={editVisible}
                width={560}
                footer={
                    <div style={{ textAlign: 'right', padding: '10px 16px' }}>
                        <Button onClick={() => setEditVisible(false)} style={{ marginRight: 8 }}>
                            取消
                        </Button>
                        <Button onClick={handleEditSubmit} type="primary">
                            确定
                        </Button>
                    </div>
                }
                destroyOnClose
            >
                <Form
                    form={editForm}
                    layout="vertical"
                    initialValues={productData}
                >
                    <Form.Item label="产品类目" name="category">
                        <Select disabled={isPublishedOrReleasing} placeholder="请选择产品类目">
                            <Option value="摄像机">摄像机</Option>
                            <Option value="网关">网关</Option>
                            <Option value="存储">存储</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="产品类型" name="subCategory">
                        <Select disabled={isPublishedOrReleasing} placeholder="请选择产品类型">
                            <Option value="4G常电">4G常电</Option>
                            <Option value="WiFi电池">WiFi电池</Option>
                            <Option value="有线存储">有线存储</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="产品名称" name="name" rules={[{ required: true, message: '请输入产品名称' }]}>
                        <Input disabled={isPublishedOrReleasing} placeholder="请输入产品名称" />
                    </Form.Item>
                    <Form.Item label="产品型号" name="model">
                        <Input disabled={isPublishedOrReleasing} placeholder="请输入产品型号" />
                    </Form.Item>
                    
                    <Form.Item label="产品图">
                        <Upload.Dragger 
                            name="file" 
                            multiple={false} 
                            action="/api/upload"
                            style={{ padding: '20px 0' }}
                        >
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">点击或拖拽图片到此区域上传</p>
                            <p className="ant-upload-hint">支持png、jpg、jpeg格式，文件大小不超过20MB</p>
                        </Upload.Dragger>
                    </Form.Item>

                    <Form.Item label="产品描述" name="desc">
                        <TextArea 
                            rows={4} 
                            placeholder="请输入产品描述" 
                            maxLength={200}
                            showCount
                        />
                    </Form.Item>
                </Form>
            </Drawer>

            {/* 物模型配置 Drawer */}
            <Drawer
                title="物模型配置"
                onClose={() => setModelDrawerVisible(false)}
                open={modelDrawerVisible}
                width={1000}
                destroyOnClose
            >
                <Tabs 
                    activeKey={activeTab} 
                    onChange={(key) => {
                        setActiveTab(key);
                        // 切换 Tab 时重置左侧菜单
                        const firstMenu = thingModelData[tabLabelMap[key]]?.['配置选项']?.[0];
                        if (firstMenu) setActiveMenu(firstMenu);
                    }}
                    items={[
                        { label: '设备能力', key: '1' },
                        { label: '镜头配置', key: '2' },
                        { label: '麦克风配置', key: '3' },
                        { label: '屏显配置', key: '4' },
                        { label: '喇叭配置', key: '5' },
                        { label: '云端抓图', key: '6' },
                    ]}
                    style={{ marginBottom: 16 }}
                />

                {/* 核心配置区域 */}
                <div style={{ padding: '0 24px' }}>
                    {/* 1. 全局配置：最顶部的独立卡片 */}
                    {activeData.globalConfig && (
                        <Card size="small" style={{ marginBottom: 16, borderRadius: 0, border: '1px solid #f0f0f0' }}>
                            <div style={{ padding: '8px 20px', borderBottom: '1px solid #f0f0f0', backgroundColor: '#fafafa', display: 'flex', alignItems: 'center' }}>
                                <Space><SettingOutlined style={{ color: '#1890ff' }} /><Text strong>全局配置</Text></Space>
                            </div>
                            <div style={{ padding: '16px 20px', display: 'flex', alignItems: 'center' }}>
                                <Text style={{ width: 140, color: '#595959' }}>{activeData.globalConfig.label} :</Text>
                                <Radio.Group value={activeData.globalConfig.value} disabled>
                                    {activeData.globalConfig.options.map(opt => (
                                        <Radio key={opt} value={opt}>{opt}</Radio>
                                    ))}
                                </Radio.Group>
                            </div>
                        </Card>
                    )}

                    {/* 2. 实例配置主卡片：包含 Camera_1 和内部 Tab 配置 */}
                    {(activeData.instanceName || (activeData.config && activeData.config.length > 0)) && (
                        <Card size="small" bodyStyle={{ padding: 0 }} style={{ borderRadius: 0, border: '1px solid #f0f0f0', marginBottom: 24 }}>
                            {/* 分类标题 (如 单目配置) */}
                            {activeData.cardTitle && (
                                <div style={{ padding: '8px 20px', borderBottom: '1px solid #f0f0f0', backgroundColor: '#fafafa', display: 'flex', alignItems: 'center' }}>
                                    <Space><CameraOutlined style={{ color: '#1890ff' }} /><Text strong>{activeData.cardTitle}</Text></Space>
                                </div>
                            )}

                            {/* 实例选择器 (Camera_1 切换) */}
                            {activeData.instanceName && (
                                <div style={{ padding: '12px 20px', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center' }}>
                                    <Space size={12}>
                                        <div style={{ padding: '4px 12px', border: '1px solid #d9d9d9', borderRadius: 4, backgroundColor: '#f5f5f5' }}>
                                            <Text strong>{activeData.instanceName}</Text>
                                        </div>
                                        {activeData.instanceLabel && (
                                            <Button size="small" type="primary" ghost>
                                                {activeData.instanceLabel} <DownOutlined style={{ fontSize: 10 }} />
                                            </Button>
                                        )}
                                    </Space>
                                </div>
                            )}

                            <Row gutter={0}>
                                {/* 内部左侧菜单 */}
                                {(thingModelData[tabLabelMap[activeTab]]?.['配置选项'] || []).length > 0 && (
                                    <Col span={4}>
                                        <div style={{ padding: '12px 0', borderRight: '1px solid #f0f0f0', height: '100%', minHeight: 400, backgroundColor: '#fafafa' }}>
                                            {thingModelData[tabLabelMap[activeTab]]['配置选项'].map(menu => (
                                                <div 
                                                    key={menu}
                                                    onClick={() => setActiveMenu(menu)}
                                                    style={{ 
                                                        padding: '10px 20px', 
                                                        cursor: 'pointer',
                                                        backgroundColor: activeMenu === menu ? '#fff' : 'transparent',
                                                        color: activeMenu === menu ? '#1890ff' : '#595959',
                                                        fontSize: 13,
                                                        fontWeight: activeMenu === menu ? 600 : 400,
                                                        borderRight: activeMenu === menu ? '3px solid #1890ff' : 'none',
                                                        marginBottom: 4,
                                                        transition: 'all 0.3s'
                                                    }}
                                                >
                                                    {menu}
                                                </div>
                                            ))}
                                        </div>
                                    </Col>
                                )}
                                {/* 内部右侧内容 */}
                                <Col span={(thingModelData[tabLabelMap[activeTab]]?.['配置选项'] || []).length > 0 ? 20 : 24}>
                                    <div style={{ padding: (activeData.multiTarget && activeData.multiTarget.length > 0) ? '24px' : '32px 48px' }}>
                                        {activeData.multiTarget && activeData.multiTarget.length > 0 ? (
                                            <>
                                                {activeData.multiTarget.map((lens, idx) => (
                                                    <Card 
                                                        key={lens.id} 
                                                        size="small" 
                                                        style={{ marginBottom: 16, borderRadius: 8, border: '1px solid #f0f0f0', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}
                                                        title={<Text strong>{lens.label}</Text>}
                                                    >
                                                        <div style={{ padding: '8px 20px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                                                                <Text style={{ width: 100, textAlign: 'right', marginRight: 24, color: '#595959' }}>镜头类型</Text>
                                                                <Select value={lens.type} disabled style={{ flex: 1 }}>
                                                                    <Option value="普通镜头">普通镜头</Option>
                                                                </Select>
                                                            </div>
                                                            <Row gutter={48}>
                                                                <Col span={12}>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <Text style={{ width: 100, textAlign: 'right', marginRight: 24, color: '#595959' }}>最大焦距</Text>
                                                                        <InputNumber value={lens.maxFocal} disabled style={{ flex: 1 }} />
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <Text style={{ width: 100, textAlign: 'right', marginRight: 24, color: '#595959' }}>最小焦距</Text>
                                                                        <InputNumber value={lens.minFocal} disabled style={{ flex: 1 }} />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Card>
                                                ))}
                                            </>
                                        ) : activeData.config.length > 0 ? (
                                            activeData.config.map((item, index) => (
                                                <div key={index} style={{ marginBottom: index === activeData.config.length - 1 ? 0 : 24, display: 'flex', alignItems: 'center' }}>
                                                    <Text style={{ width: 140, textAlign: 'right', marginRight: 24, color: '#595959' }}>{item.label}</Text>
                                                    <div style={{ flex: 1 }}>
                                                        {item.type === 'checkbox' ? (
                                                            <Checkbox.Group value={item.value} disabled style={{ width: '100%' }}>
                                                                <Space size={32} wrap>
                                                                    {item.options.map(opt => (
                                                                        <Checkbox key={opt} value={opt}>{opt}</Checkbox>
                                                                    ))}
                                                                </Space>
                                                            </Checkbox.Group>
                                                        ) : item.type === 'radio' ? (
                                                            <Radio.Group value={item.value} disabled>
                                                                <Space size={32} wrap>
                                                                    {item.options.map(opt => (
                                                                        <Radio key={opt} value={opt}>{opt}</Radio>
                                                                    ))}
                                                                </Space>
                                                            </Radio.Group>
                                                        ) : item.type === 'switch' ? (
                                                            <Switch checked={item.value} disabled size="small" />
                                                        ) : item.type === 'input-number' ? (
                                                            <InputNumber value={item.value} disabled size="small" style={{ width: 120 }} />
                                                        ) : item.type === 'select' ? (
                                                            <Select value={item.value} disabled size="small" style={{ width: 160 }}>
                                                                {item.options.map(opt => (
                                                                    <Select.Option key={opt} value={opt}>{opt}</Select.Option>
                                                                ))}
                                                            </Select>
                                                        ) : item.type === 'title' ? (
                                                            <div style={{ marginBottom: 12, paddingBottom: 8, borderBottom: '1px dashed #f0f0f0' }}>
                                                                <Text strong style={{ fontSize: 14 }}>{item.label}</Text>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div style={{ padding: '80px 0', textAlign: 'center' }}>
                                                <Text type="secondary">暂无配置项</Text>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    )}
                </div>

                {/* 下方能力表格：横向充满 Drawer (不在 Row/Col 容器内) */}
                <div style={{ padding: '0 24px 24px' }}>
                    {/* 标准能力表格 */}
                    {!activeData.hideTables && (
                        <Card size="small" style={{ marginBottom: 24, borderRadius: 0, border: '1px solid #f0f0f0' }}>
                            <div style={{ padding: '4px 12px 12px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                    <Space>
                                        <Text strong style={{ fontSize: 14 }}>标准能力</Text>
                                        <QuestionCircleOutlined style={{ color: '#8c8c8c', fontSize: 14 }} />
                                    </Space>
                                </div>
                                <Table 
                                    size="small"
                                    pagination={false}
                                    columns={[
                                        { title: '类型', dataIndex: 'type', key: 'type', width: 100 },
                                        { title: '能力名称', dataIndex: 'name', key: 'name' },
                                        { title: '能力标识', dataIndex: 'identifier', key: 'identifier' },
                                        { title: '数据类型', dataIndex: 'dataType', key: 'dataType' },
                                        { title: '数据定义', dataIndex: 'dataDef', key: 'dataDef' },
                                        { title: '描述', dataIndex: 'desc', key: 'desc' },
                                        { title: '所属模块', dataIndex: 'module', key: 'module' },
                                        { title: '操作', key: 'action', render: () => <Text type="secondary">-</Text> }
                                    ]}
                                    dataSource={activeData.standard}
                                    locale={{ emptyText: '暂无数据' }}
                                />
                            </div>
                        </Card>
                    )}

                    {/* 自定义能力表格 */}
                    {!activeData.hideTables && (
                        <Card size="small" style={{ marginBottom: 24, borderRadius: 0, border: '1px solid #f0f0f0' }}>
                            <div style={{ padding: '4px 12px 12px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                    <Space>
                                        <Text strong style={{ fontSize: 14 }}>自定义能力</Text>
                                        <QuestionCircleOutlined style={{ color: '#8c8c8c', fontSize: 14 }} />
                                        <Text type="secondary" style={{ fontSize: 12, marginLeft: 8 }}>您所定义的每一个功能，都与固件、APP控制台面板相关</Text>
                                    </Space>
                                </div>
                                <Table 
                                    size="small"
                                    pagination={false}
                                    columns={[
                                        { title: '类型', dataIndex: 'type', key: 'type', width: 100 },
                                        { title: '能力名称', dataIndex: 'name', key: 'name' },
                                        { title: '能力标识', dataIndex: 'identifier', key: 'identifier' },
                                        { title: '数据类型', dataIndex: 'dataType', key: 'dataType' },
                                        { title: '数据定义', dataIndex: 'dataDef', key: 'dataDef' },
                                        { title: '描述', dataIndex: 'desc', key: 'desc' },
                                        { title: '所属模块', dataIndex: 'module', key: 'module' },
                                        { title: '操作', key: 'action', render: () => <Text type="secondary">-</Text> }
                                    ]}
                                    dataSource={activeData.custom}
                                    locale={{ emptyText: '暂无数据' }}
                                />
                            </div>
                        </Card>
                    )}
                </div>
            </Drawer>

            {/* 设备使用区域设置弹窗 */}
            <Modal title="设备使用区域设置" open={regionModalVisible}
                onOk={async () => { const v = regionForm.getFieldsValue(); setRegionMode(v.regionMode); setSelectedCountries(v.selectedCountries || []); setRegionModalVisible(false); message.success('设备使用区域已更新'); }}
                onCancel={() => setRegionModalVisible(false)} okText="保存" cancelText="取消" destroyOnClose width={520}
            >
                <Form form={regionForm} layout="vertical" style={{ marginTop: 16 }}>
                    <Form.Item label="限制模式" name="regionMode">
                        <Radio.Group onChange={(e) => regionForm.setFieldsValue({ regionMode: e.target.value })}>
                            <Radio value="none">不限制</Radio>
                            <Radio value="whitelist">白名单（仅允许）</Radio>
                            <Radio value="blacklist">黑名单（禁止使用）</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item noStyle shouldUpdate={(p, c) => p.regionMode !== c.regionMode}>
                        {({ getFieldValue }) => getFieldValue('regionMode') !== 'none' ? (
                            <Form.Item label={getFieldValue('regionMode') === 'whitelist' ? '允许使用的国家/地区' : '禁止使用的国家/地区'} name="selectedCountries">
                                <Select mode="multiple" placeholder="请选择国家/地区" showSearch optionFilterProp="label" style={{ width: '100%' }}
                                    maxTagCount={5} maxTagPlaceholder={(omitted) => `+${omitted.length}个`}
                                    options={[
                                        { label: '亚洲', options: [{ value: 'CN', label: '中国' }, { value: 'JP', label: '日本' }, { value: 'KR', label: '韩国' }, { value: 'IN', label: '印度' }, { value: 'SG', label: '新加坡' }, { value: 'TH', label: '泰国' }, { value: 'VN', label: '越南' }, { value: 'MY', label: '马来西亚' }, { value: 'PH', label: '菲律宾' }, { value: 'ID', label: '印度尼西亚' }, { value: 'PK', label: '巴基斯坦' }, { value: 'BD', label: '孟加拉国' }, { value: 'AE', label: '阿联酋' }, { value: 'SA', label: '沙特阿拉伯' }, { value: 'IL', label: '以色列' }, { value: 'TR', label: '土耳其' }] },
                                        { label: '欧洲', options: [{ value: 'GB', label: '英国' }, { value: 'DE', label: '德国' }, { value: 'FR', label: '法国' }, { value: 'IT', label: '意大利' }, { value: 'ES', label: '西班牙' }, { value: 'NL', label: '荷兰' }, { value: 'SE', label: '瑞典' }, { value: 'PL', label: '波兰' }, { value: 'CH', label: '瑞士' }, { value: 'NO', label: '挪威' }, { value: 'RU', label: '俄罗斯' }, { value: 'UA', label: '乌克兰' }] },
                                        { label: '北美洲', options: [{ value: 'US', label: '美国' }, { value: 'CA', label: '加拿大' }, { value: 'MX', label: '墨西哥' }] },
                                        { label: '南美洲', options: [{ value: 'BR', label: '巴西' }, { value: 'AR', label: '阿根廷' }, { value: 'CL', label: '智利' }, { value: 'CO', label: '哥伦比亚' }] },
                                        { label: '大洋洲', options: [{ value: 'AU', label: '澳大利亚' }, { value: 'NZ', label: '新西兰' }] },
                                        { label: '非洲', options: [{ value: 'ZA', label: '南非' }, { value: 'EG', label: '埃及' }, { value: 'NG', label: '尼日利亚' }, { value: 'KE', label: '肯尼亚' }] },
                                    ]}
                                />
                            </Form.Item>
                        ) : null}
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default ProductInformation;
